import { ColoursObj, MobileSnackBarCard, Typography, useSnackListStore } from "@eventr/common-storybook";
import { AlertColor } from "@mui/material";
import type { ReactNode } from "react";
import { isIosToastAvailable, showNativeSnack } from "./native-toast";
import { useOverlayStore } from "./overlay.store";

const MAX_VISIBLE_SNACKS = 3;

export function addToSnackQueue(nodeComp: ReactNode, uId: number) {
  while (useSnackListStore.getState().snackList.length >= MAX_VISIBLE_SNACKS) {
    const oldest = useSnackListStore.getState().snackList[0];
    if (!oldest) break;
    useSnackListStore.getState().removeSnackFromList(oldest.uId);
  }
  useSnackListStore.getState().addSnackToList(nodeComp, uId);
}

const fontColour = (severity: AlertColor) => {
  switch (severity) {
    case "error": {
      return ColoursObj.shades.shade5;
    }
    case "warning": {
      return ColoursObj.shades.shade5;
    }
    case "success": {
      return ColoursObj.shades.shade5;
    }
    default: {
      return ColoursObj.font.primary;
    }
  }
};

export function defaultAddSnack(
  message: string,
  severity: AlertColor,
  stack: boolean = true,
  uniqueMessageId?: string,
) {
  if (uniqueMessageId) {
    if (!useOverlayStore.getState().markSnackShown(uniqueMessageId)) return;
  }
  if (isIosToastAvailable()) {
    void showNativeSnack(message, severity, stack);
    return;
  }
  const snackListStore = useSnackListStore.getState();
  const uId = snackListStore.getUId();
  if (!stack) snackListStore.clearList();
  addToSnackQueue(
    <MobileSnackBarCard
      severity={severity}
      onXClick={() => {
        snackListStore.removeSnackFromList(uId);
      }}
    >
      <Typography
        color={fontColour(severity)}
        sx={{
          textAlign: "center",
          fontSize: "14px",
          fontWeight: "400",
          fontFamily: "CountryFlags, Inter-100-500",
          lineHeight: "16px",
        }}
      >
        {message}
      </Typography>
    </MobileSnackBarCard>,
    uId,
  );
}
